export function useMenuPinned() {
  return useState<boolean>('menuIsPinned', () => {
    return typeof localStorage !== 'undefined' && localStorage.getItem('iqa-menu-pinned') === 'true';
  });
}
